import React from 'react';
import moment from 'moment';
import {typography} from 'material-ui/styles';

import Booked from './slots/booked';
import Available from './slots/available';
import NotScheduled from './slots/NotScheduled';
import NoSchedule from './slots/no-schedule';
import utils from '../../utility/utils';
import {List, ListItem} from 'material-ui/List';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton/RaisedButton';
import { grey800} from 'material-ui/styles/colors';


const styles = {
  panel: {
    backgroundColor: '#fff',
    border: 'none',
    position: 'relative',
    width: '99%',
    fontWeight: typography.fontWeightLight,
    marginTop: '25px',
  },
  slot:{
    fontSize: 18,
    textAlign:'center'

  },
  table: {
    width: '100%',
    padding: '10px',
    border: '1px solid',
    backgroundColor: 'white'
  },
  td: {
    padding: '10px',
    textAlign: 'center',
    borderBottom: '1px solid #ddd',
    borderRight: '1px solid #ddd',
    width: '35px'
  }
};





const ScheduleList = ({slots, schedules, appointments, displayMissionDetail,
   showSchedulesOpen, toggleShowSchedulesOpen, clickedDoctor, clickedSlot, setSlotWithDoctor, deleteSchedule
  }) => {

  schedules = (schedules && schedules.toArray()) || [];
  appointments = (appointments && appointments.toArray()) || [];



  const isSlotAvailable = (slot, doctor) => {
    let doctorSchedules = doctor.schedule;
    let schedule = doctorSchedules.find((schedule) => {

      let startTime = moment(schedule.start_time);
      let endTime = moment(schedule.end_time);

      return slot.isBetween(startTime, endTime, 'minutes', '[)')

    });
    return schedule;
  }

  const isBooked = (slot, doctor) => {

    let doctorAppointments = appointments.find((appointment) => {
      return doctor.id === appointment.group;
    });

    if (!doctorAppointments) return null;

    let appointment = doctorAppointments.reduction.find((appointment) => {

      let startTime = moment(appointment.start_time);
      return slot.isSame(startTime, 'minutes');
    });
    return appointment;

  }

  const renderTile = (slot, doctor, index) => {

    let appointment = isBooked(slot, doctor);

    if (appointment) {

      let tile = slot.isSame(appointment.start_time, 'minutes') ?
        <Booked
          key={index}
          slot={slot}
          doctor={doctor}
          index={index}
          appointment={appointment}
          setSlotWithDoctor={setSlotWithDoctor}
        />
        :
        null;

      return tile;

    } else if (isSlotAvailable(slot, doctor)) {

      return (
        <Available
          key={index}
          slot={slot}
          index={index}
          doctor={doctor}
          setSlotWithDoctor={setSlotWithDoctor}
        />
      )

    } else {
        return (
          <NotScheduled
            key={index}
            index={index}
        />
        )
    }

  }

  const displaySelectedSchedule = (doctor, slot) => {
    let schedulesByDoctor = schedules.filter((doc) => (
      doc.id === doctor.id
    ));

    const actions = [
      <RaisedButton
       label="Close"
       style={{marginRight: '290px', width: '20%'}}
       labelStyle={{color:'white'}}
       backgroundColor={grey800}
       onClick={toggleShowSchedulesOpen}
      />
    ]
    return <Dialog
        modal={false}
        open={showSchedulesOpen}
        title="Schedule"
        actions={actions}
        autoScrollBodyContent={true}
        onRequestClose={toggleShowSchedulesOpen}>
        <List>
        {
          schedulesByDoctor.length > 0 && schedulesByDoctor.map((doctor) => {
            return doctor.schedule.map((schedule, i) => {
              if(slot.isBetween(moment(schedule.start_time), moment(schedule.end_time), 'minutes', '[)')) {
                return (
                <ListItem
                key={i}
                primaryText={`Schedule from ${utils.toAppTime(schedule.start_time)} to 
                ${utils.toAppTime(schedule.end_time)}`}
                rightIconButton= {
                    <RaisedButton
                    label="Delete"
                    style={{marginTop: '8px', marginRight: '200px', width: '20%'}}
                    labelStyle={{color:'white'}}
                    backgroundColor='#D02504'
                    onClick={deleteSchedule.bind(null, schedule.id)}
                    />
                  }
                />)
              } return <div/>;
            });


          })
        }
      </List>
    </Dialog>

  }

  return (
    <div>
      {
        clickedDoctor && clickedSlot &&
        displaySelectedSchedule(clickedDoctor, clickedSlot)
      }
      <h1>Schedules</h1>
      {schedules.length === 0 && <NoSchedule/>}
      <div style={styles.panel} className="Schedules">
        {schedules.length > 0 &&
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.td}>Slots</th>
                {schedules.map((doctor, index) => {
                  return (<th style={styles.td} key={index}>{doctor.user.name}
                    </th>)
                }
                )}
              </tr>
            </thead>
            <tbody>
              {slots.map((slot, slotIndex) => {
                return (
                  <tr key={slotIndex}>
                    <td style={styles.td}>{utils.toAppTime(slot)}</td>
                    {schedules.map((doctor, index) => {
                      return (renderTile(slot, doctor, index))
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        }

      </div>

    </div>
  )
};

export default ScheduleList;




// WEBPACK FOOTER //
// ./src/screens/schedules/schedules-table.js